import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import { SignupSchema } from "../const/schema";
import "react-phone-input-2/lib/style.css";
import { createUserApi } from "../api/createUserApi";
import { updateUserApi } from "../api/updateUserApi";
import { toast } from "react-toastify";

export const SignupForm = ({ initialData = null, refreshUsers }) => {
  const isEdit = !!initialData;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold mb-6 text-gray-800 text-center">
          {isEdit ? "Editar Usuario" : "Registrar Usuario"}
        </h2>

        <Formik
          initialValues={{
            nombre: initialData?.nombre || "",
            apellidos: initialData?.apellidos || "",
            email: initialData?.email || "",
            telefono: initialData?.telefono || "",
            foto: initialData?.foto || "",
          }}
          validationSchema={SignupSchema}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
              if (isEdit) {
                await updateUserApi({ ...values, id: initialData.id });
              } else {
                await createUserApi(values);
              }
              refreshUsers();
              toast("Operación Exitosa");
            } catch (error) {
              console.error("Error al procesar:", error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium">
                  Nombre
                </label>
                <Field
                  name="nombre"
                  className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ErrorMessage
                  name="nombre"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">
                  Apellidos
                </label>
                <Field
                  name="apellidos"
                  className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ErrorMessage
                  name="apellidos"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">Email</label>
                <Field
                  type="email"
                  name="email"
                  readOnly={isEdit}
                  className={`mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                    isEdit ? "bg-gray-100 cursor-not-allowed" : ""
                  }`}
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">
                  Teléfono
                </label>
                <Field name="telefono">
                  {({ field }) => (
                    <PhoneInput
                      country={"us"}
                      value={field.value}
                      onChange={(value) => setFieldValue("telefono", value)}
                      inputClass="!p-2 !pl-12 !w-full !border !border-gray-200 !rounded-md !focus:outline-none !focus:ring-2 !focus:ring-blue-500"
                      containerClass="!w-full"
                      buttonClass="!bg-gray-200 !border !border-gray-200"
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="telefono"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">
                  Foto (base64)
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                      setFieldValue("foto", reader.result);
                    };
                    reader.readAsDataURL(e.currentTarget.files[0]);
                  }}
                  className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <ErrorMessage
                  name="foto"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div className="pt-6">
                <button
                  type="submit"
                  className="w-full bg-blue-700 text-white p-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Procesando..."
                    : isEdit
                    ? "Actualizar"
                    : "Registrar"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
